import IsBasicKey from './is-basic-key'

export default IsBasicKey
